import { Modal, Button, ButtonToolbar, ButtonGroup } from 'react-bootstrap';
import { Form as FinalForm } from 'react-final-form';
import setFieldTouched from 'final-form-set-field-touched';

import Field from '../../components/form/rff_field';
import InputField from '../../components/form/input_field';
import SubmitButtonSpinner from '../../components/submit_button_spinner';

function RawScanReceiptModal(props) {
  const { show, onCancel, onComplete } = props;

  const onFormSubmit = async (data) => {
    onComplete(data.rawValue);
  };

  return (
    <Modal
      id="raw-scan-receipt"
      show={show}
      onHide={onCancel}
      centered
      size="xl"
      animation={false}
    >
      <FinalForm onSubmit={onFormSubmit} mutators={{ setFieldTouched }}>
        {({ handleSubmit, submitting, pristine }) => (
          <form noValidate onSubmit={handleSubmit}>
            <Modal.Header closeButton>
              <Modal.Title>Add Raw Scan Value</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Field
                name="rawValue"
                component={InputField}
                labelWidth={2}
                inputWidth={10}
                size="lg"
              >
                Raw
              </Field>
            </Modal.Body>
            <Modal.Footer>
              <ButtonToolbar className="d-flex justify-content-end w-100">
                <ButtonGroup className="me-2">
                  <Button variant="danger" onClick={onCancel} disabled={submitting}>
                    Cancel
                  </Button>
                  <Button
                    type="button"
                    variant="primary"
                    disabled={pristine || submitting}
                    onClick={handleSubmit}
                  >
                    {submitting && <SubmitButtonSpinner />}
                    Create
                  </Button>
                </ButtonGroup>
              </ButtonToolbar>
            </Modal.Footer>
          </form>
        )}
      </FinalForm>
    </Modal>
  );
}

export default RawScanReceiptModal;
